export const generateDealSummaryQueryKey = (dealId: string) => [
  'data',
  'dealSummary',
  dealId,
];
